import React, { useRef, useState, useEffect } from 'react'
import { message, Modal, Spin } from 'antd'
import { renderCompat } from '../../utils/renderCompat'
import RightRenderTab from '../addInspirationModal/rightRenderTab'
import RightHeader from '../addInspirationModal/rightHeader'
import FileTreeData from '../../common/fileTreeData'
import util from '../../utils/util'
import * as userAuth from '../../utils/auth'
import AssociateTaskModal from '../associateTaskModal'
import request from '../../utils/request'
import Icon from '../icon'
import Upload from '../upload/image'
import TreeOption from '../inspirationTreeList'
import AddInspirationFromWrap from '../addInspirationModal/addInspirationFromWrap'
import { queryTypeList, QUERY_TYPE_VALUE } from '../addInspirationModal/enum'
import { getTagNameList } from '../addInspirationModal/utils'
import Arrow from './arrow'
import './index.less'

export default function UploadIns(props) {
  const { callback, inspirationId } = props
  const [visible, setVisible] = useState(props.visible)
  const [imgList, setImgList] = useState([])
  const [currentIndex, setCurrentIndex] = useState(0)
  const [loading, setLoading] = useState(false)
  const [count, setCount] = useState(0)
  const [progress, setProgress] = useState(0)
  const [errorTip, setErrorTip] = useState(false)
  const [taskConfirm, setTaskConfirm] = useState(false)
  const isCloseUpload = useRef(false)
  const taskData = useRef(null)

  const [formParams, setFromParams] = useState({
    tags: new Set(), // tagNameList 标签列表
    price: null, // 参考价格
    description: null, // 描述
    gender: null, // 行业
    styleTitle: '',
    propertyValueParamList: [], // 自定义属性实体信息
  })

  const onConfirm = async (insList) => {
    if (!imgList.length) {
      setErrorTip(true)
      message.warning('请先上传图片')
      return
    }
    if (!insList.length) {
      message.error('请选择加入的灵感集')
      return
    }

    const res = await request.post('/zhikuan/user-img/upload-img', {
      inspirationIdList: insList.map(m => m.id),
      itemList: imgList,
      ...formParams,
      tagNameList: getTagNameList(formParams?.tags)
    })
    if (insList.length === 1) {
      message.success(<span>已成功上传至<a className="link" href={`/meinian/home/coll/detail/${insList[0].id}?inspirationId=${insList[0].id}`} target="_blank" rel="noreferrer">{insList[0].name}</a></span>)
      callback && callback(insList[0])
      if (res?.effectTargetNum && userAuth.isPermissions(res?.loginUserInfo?.inspirationPermissions, ['F21']) && res.collectIdList?.length <= 1) {
        taskData.current = res
        setTaskConfirm(true)
        setVisible(false)
      } else {
        setVisible(false)
      }
    } else {
      callback && callback(insList[0])
      message.success('上传成功')
      setVisible(false)
    }
    util.track('mn-add-style', {
      module1: '上传',
      module2: '上传款式'
    })
  }

  const onTaskConfirmOk = async () => {
    setTaskConfirm(false)
  }

  const onUpload = async (file) => {
    if (isCloseUpload.current) {
      setImgList([])
      setProgress(0)
      setLoading(false)
      setCount(0)
      isCloseUpload.current = false
      return
    }
    setImgList(file.map(v => {
      // eslint-disable-next-line no-unsafe-optional-chaining
      const imgName = v?.filename?.substring(v?.filename?.lastIndexOf('/') + 1, v?.filename?.lastIndexOf('.'))
      return {
        mainUrl: v?.url,
        fileName: v?.filename,
        height: v.height,
        width: v.width,
        tagNameList: [],
        hashMD5: v.hashMD5,
        title: imgName,
        desc: '',
      }
    }))
    setProgress(0)
    setLoading(false)
    setCount(0)
  }

  const onPreventUpload = () => {
    Modal.confirm({
      title: '提示',
      content: '确定取消上传',
      centered: true,
      className: 'delete-tag-confirm',
      onOk: () => {
        setImgList([])
        setLoading(false)
        setCount(0)
        isCloseUpload.current = true
      },
      okText: '确定',
      cancelText: '取消',
    })
  }
  const onDeleteImg = () => {
    imgList.splice(currentIndex, 1)
    if (currentIndex === imgList.length && imgList.length) {
      setCurrentIndex(pre => pre - 1)
    }
    setImgList([...imgList])
  }

  const onCancelModal = () => {
    if (!loading) {
      setVisible(false)
      return
    }
    Modal.confirm({
      title: '提示',
      content: '确定关闭上传灵感？关闭上传灵感已上传的图片将无法恢复。',
      centered: true,
      className: 'delete-tag-confirm',
      onOk: () => {
        setVisible(false)
      },
      okText: '确定',
      cancelText: '取消',
    })
  }

  const onFormChange = (valObj) => {
    setFromParams(pre => ({ ...pre, ...valObj }))
  }

  return <>
    {taskConfirm && <AssociateTaskModal
      collectId={taskData.current?.collectIdList?.[0] || taskData.current?.collectId}
      visible={taskConfirm}
      onClose={() => {
        setTaskConfirm(false)
      }}
      onOk={onTaskConfirmOk}
    />}
    <Modal
      centered
      visible={visible}
      bodyStyle={{ padding: 0, borderRadius: '9px', overflow: 'hidden' }}
      width={884}
      wrapClassName="mn-add-into-idea-mass-modal-wrapper"
      onCancel={() => onCancelModal()}
      closable={false}
      footer={null}
    >
      <div className="mn-upload-ins-modal">
        <div className="mn-upload-ins-modal-left">
          <AddInspirationFromWrap
            listWidth={420}
            formParams={formParams}
            onFormChange={onFormChange}
          >
            <div style={{ marginBottom: 8 }}>
              {loading && <div className="mn-upload-ins-loading">
                <div className="mn-upload-ins-loading-icon"><Spin indicator={<Icon type="m-jiazaizhong" spin />} spinning={loading} /></div>
                正在上传{`${progress}/${count}`}
                <div className="mn-upload-ins-loading-cancel" onClick={() => onPreventUpload()}>取消</div>
              </div>}
              {!imgList.length || loading ? <Upload
                onSuccess={file => onUpload(file)}
                onStartUpload={() => {
                  setLoading(true)
                }}
                onEndUpload={() => {
                  setLoading(false)
                }}
                onUploadProgress={(progressFiles, files) => {
                  if (!isCloseUpload.current) {
                    const progressCount = progressFiles.filter(item => item.event.progress === 1).length
                    setProgress(progressCount)
                    setCount(files.length)
                  }
                }}
                multiple
                customDir="data_infra/26/"
                maxSize={20}
                maxCount={30}
              >
                <div className="mn-upload-ins-upload-area">
                  <Icon type="m-tianjia" className="mn-upload-ins-upload-icon" />
                  <div className="explain" style={{ color: errorTip ? '#ff5555' : '' }}>点击选择或拖拽图片到这里</div>
                  <div className="tip">支持单张20MB以内的JPG、JPEG、PNG格式图片上传,<br />单次最多上传30张</div>
                </div>
              </Upload> : <div className="mn-upload-ins-images" style={{ backgroundImage: `url(${imgList[currentIndex].mainUrl})` }}>
                {imgList.length > 1 ? <>
                  <Arrow
                    step={-1}
                    imgList={imgList}
                    index={currentIndex}
                    setIndex={currentIndex > 0 ? setCurrentIndex : null}
                    type="left"
                  />
                  <Arrow
                    step={1}
                    imgList={imgList}
                    index={currentIndex}
                    setIndex={currentIndex < imgList.length - 1 ? setCurrentIndex : null}
                    type="right"
                  />
                </> : null}
                <div className="mn-upload-ins-images-top">
                  <div className="top-item">{currentIndex + 1} / {imgList.length}</div>
                  <div className="top-item icon" onClick={() => onDeleteImg()}><Icon type="m-shanchu" /></div>
                </div>
              </div>}
            </div>
          </AddInspirationFromWrap>
        </div>
        <UploadInsRight
          inspirationId={inspirationId}
          imgList={imgList}
          onCancel={() => onCancelModal()}
          onConfirm={onConfirm}
          onDefaultCreateInspiration={() => {
            if (!imgList.length) {
              setErrorTip(true)
              message.warning('请先上传图片')
              return true
            }
            return false
          }}
        />
      </div>
    </Modal>
  </>
}

UploadIns.Show = (props) => {
  let div = document.createElement('div')
  return new Promise(() => {
    div = document.createElement('div')
    document.body.appendChild(div)
    // eslint-disable-next-line react/no-deprecated
    renderCompat(<UploadIns {...props} visible container={div} />, div)
  })
}

const UploadInsRight = ({ onConfirm, onCancel, inspirationId, onDefaultCreateInspiration }) => {
  const [loading, setLoading] = useState(false)
  const [dataList, setDataList] = useState([])
  const [queryType, setQueryType] = useState(3)
  const [selectIds, setSelectIds] = useState([])
  const [selectItems, setSelectItems] = useState([])
  const [singleCollection, setSingleCollection] = useState(true) // 单选采集

  const [currentIdeaMass, setCurrentIdeaMass] = useState(null)
  const treeData = useRef()

  const [keyWords, setKeyWords] = useState()
  const pageParams = useRef({
    start: 0,
    pageSize: 20
  })
  const resultList = useRef([])
  const totalRef = useRef(0)

  useEffect(() => {
    fetchIdeaMassList(queryType)
  }, [])

  const fetchIdeaMassList = async (
    _queryType,
    _keyWords = keyWords,
    _pageParams = pageParams.current,
  ) => {
    setLoading(true)
    try {
      const res = await request.post('/zhikuan/ins/inspiration/list-collect-inspiration-tree', {
        queryType: _queryType,
        ..._pageParams,
        likeName: _keyWords,
      })
      totalRef.current = res.resultCount
      const tempResult = _pageParams.start === 0
        ? resultList.current = res.resultList : resultList.current = [...resultList.current, ...res.resultList]
      treeData.current = new FileTreeData({
        data: tempResult,
        checkedValues: selectIds,
        childrenKey: 'childs',
      })
      if (inspirationId) {
        const _currentData = treeData.current.findNodeByValue(inspirationId)
        setCurrentIdeaMass(_currentData?.current)
      }
      setDataList(treeData.current.data)
    } catch (err) {
      console.error('fetchIdeaMassList', err)
    }
    setLoading(false)
  }

  const onCreateInspiration = (id, name) => {
    onConfirm([{ id, name }])
  }

  const queryTypeChange = (val) => {
    if (val === queryType) return
    setQueryType(val)
    fetchIdeaMassList(val, 0)
  }

  const onTreeChange = (checked, currentItem) => {
    if (checked) {
      treeData.current.checkSelectMarkStatus(currentItem)
      selectItems.push(currentItem)
      selectIds.push(currentItem.value)
    } else {
      treeData.current.checkNoSelectMarkStatus(currentItem)
      const _findIndex = selectIds.findIndex(i => i === currentItem.value)
      const _currentFindIndex = selectItems.findIndex(i => i.value === currentItem.value)
      selectItems.splice(_currentFindIndex, 1)
      selectIds.splice(_findIndex, 1)
    }
    treeData.current.controlQuantity(checked, currentItem)
    setSelectIds(pre => [...pre])
    setSelectItems(pre => [...pre])
  }

  const onItemCollect = (_, inspiration) => {
    onConfirm([inspiration])
    return false
  }

  const treeOptionRef = useRef(null)

  return (<div className="mn-upload-ins-modal-right">
    <div className="mn-add-into-idea-mass-modal-header-2">
      上传至美念
      <div className="add-into-idea-mass-modal-close" onClick={() => onCancel()}><Icon type="m-guanbi" /></div>
    </div>
    <RightHeader
      selects={selectIds}
      onClear={async () => {
        setSelectIds([])
        setSelectItems([])
        await fetchIdeaMassList(queryType)
        treeOptionRef.current?.onClear()
      }}
      mode={singleCollection}
      onMode={async () => {
        setSingleCollection(!singleCollection)
        await fetchIdeaMassList(queryType)
        treeOptionRef.current?.onClear()
      }}
    />
    <TreeOption
      onLoad={() => {
        pageParams.current.start += 20
        if (pageParams.current.start < totalRef.current) {
          fetchIdeaMassList(queryType)
        }
      }}
      keyWords={keyWords}
      onKeyWords={(val) => {
        pageParams.current.start = 0
        fetchIdeaMassList(queryType, val)
        setKeyWords(val)
      }}
      ref={treeOptionRef}
      singleCollection={singleCollection}
      onItemCollect={onItemCollect}
      collectBtn="上传"
      collectBtnDisabled={!selectItems.length}
      //
      onCancel={onCancel}
      onOk={() => onConfirm(selectItems)}
      treeData={treeData.current}
      tabOptionHead={queryTypeList.find(item => queryType === item.value)}
      renderTab={() => <RightRenderTab
        option={queryTypeList.filter(i => i.value !== QUERY_TYPE_VALUE.collected)}
        value={queryType}
        onChange={queryTypeChange}
        data={dataList}
      />}
      currentOptionItem={currentIdeaMass}
      data={dataList}
      scrollHeight={400}
      listWidth={463}
      value={selectIds}
      loading={loading}
      onDefaultCreateInspiration={onDefaultCreateInspiration}
      onCreateInspiration={onCreateInspiration}
      onChange={onTreeChange}
    />
  </div>)
}
